import Swiper from 'swiper/bundle';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import scroll from '../utils/scroll';

//AIzaSyAwRY6zaGqvVDNMBS5i_11zotW06NYaZyg

// Importation de LocomotiveScroll pour utiliser directement l'instance créée
import LocomotiveScroll from 'locomotive-scroll';

gsap.registerPlugin(ScrollTrigger);

const landing = {
    init() {
        this.initSwipers();
        this.initFormNavigation();
        this.initFormation();
        this.initMap();
    },
    initSwipers() {
        // const swiper_annonces = new Swiper('._swiper_campus', {
        //     direction: 'horizontal',
        //     spaceBetween: 20,
        //     breakpoints: {
        //         0: {
        //             slidesPerView: 1.1,
        //         },
        //         600: {
        //             slidesPerView: 1.3,
        //         },
        //         900: {
        //             slidesPerView: 2.3,
        //         },
        //         1300: {
        //             slidesPerView: 2.3,
        //         },
        //     }
        // });
    },
    initMap() {
        // Latitude and longitude of the address
        const location = { lat: 45.785738, lng: 4.802289 };

        // Create the map
        const map = new google.maps.Map(document.getElementById("map"), {
            center: location,
            zoom: 15, // Adjust zoom level
            disableDefaultUI: true, // Disable default UI
            zoomControl: true, // Enable zoom controls
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT, // Position in the top right
            },
            styles: [
                {
                    elementType: "geometry",
                    stylers: [{ color: "#f5f5f5" }]
                },
                {
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }]
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [{ color: "#616161" }]
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [{ color: "#f5f5f5" }]
                },
                {
                    featureType: "administrative.land_parcel",
                    elementType: "labels.text.fill",
                    stylers: [{ color: "#bdbdbd" }]
                },
                {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [{ color: "#eeeeee" }]
                },
                {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{ color: "#757575" }]
                },
                {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [{ color: "#ffffff" }]
                },
                {
                    featureType: "road.arterial",
                    elementType: "labels.text.fill",
                    stylers: [{ color: "#757575" }]
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{ color: "#dadada" }]
                },
                {
                    featureType: "road.highway",
                    elementType: "labels.text.fill",
                    stylers: [{ color: "#616161" }]
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{ color: "#c9c9c9" }]
                },
                {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{ color: "#9e9e9e" }]
                }
            ]
        });

        const markerSize = window.innerWidth > 768
            ? { width: 100, height: 97 } // Large icône
            : { width: 60, height: 58 }; // Petite icône

        const markerIcon = {
            url: _SITE_URL + "img/SITE/LANDING/marker_map.png", // Chemin de l'image
            scaledSize: new google.maps.Size(markerSize.width, markerSize.height), // Taille du marqueur
            origin: new google.maps.Point(0, 0), // Origine de l'image
            anchor: new google.maps.Point(markerSize.width / 2, markerSize.height / 2) // Ancrage au centre
        };

        // Add custom marker
        new google.maps.Marker({
            position: location,
            map: map,
            icon: markerIcon
        });
    },
    initFormation() {
        $(document).on("click", "._formation > h3", function () {
            let _elt = $(this).parent();
            _elt.toggleClass("_open");
            $("._formation").not(_elt).removeClass("_open");
        });
    },
    initFormNavigation() {

        let _this = this;

        _this.loadForm("4821b39d-d097-4771-85e8-98b139763d9c");

        $(document).on("click", "._open_form", function () {
            let formId = $(this).data("form");
            let title = $(this).data("title");
            $("._nav_brochures[data-form="+formId+"]").addClass("_open");
            $("._nav_brochures[data-form!="+formId+"]").removeClass("_open");
            _this.loadForm(formId);
            $("._form_tpf > h3").html(title);
        });


    },
    loadForm(formId) {
        document.getElementById("containForm").innerHTML = "";
        // Création du formulaire HubSpot
        hbspt.forms.create({
            portalId: "143255337",
            formId: formId,
            target: "#containForm"
        });
    },
};

export default landing;
